import React, { Component } from "react";
import {
  Route,
  Redirect,
} from "react-router-dom";

function ProtectedRoute({ auth, component: Component, ...rest }) {
  console.log("Protected Auth: ", auth, 'Component:', Component);
  return (
    <Route
      {...rest}
      // render={() => auth ? (<div>Authorized</div>) : (<div>Not Authorized</div>)}
      // render={() => <div>Hello</div>}
      render={() => (auth ? <Component /> : <Redirect to="/login" />)}
    />
  );
}

export default ProtectedRoute;
